import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/ProductTile/ProductHero/LazyVideo.js";
const variants = import.meta.webpackContext("/components/ProductTile/ProductHero", { recursive: true, regExp: /\.\/__variants__\/plp\-mweb\-image\-gallery\/v2\/LazyVideo\.js/ });
export default pointCut({ joinPoint, variants });